<template>
  <div class="print" style="display: block">
    <!-- main -->
    <div class="col-12 main">
      <div class="row no-printable">
        <div class="col-12 mb-2">
          <div class="title-admin">
            <h1 class="display-3 font-weight-black">Productos</h1>
            <v-btn color="red darken-1" dark large @click="$router.go(-1)"
              ><v-icon class="mr-3">close</v-icon>Salir</v-btn
            >
          </div>
        </div>
      </div>

      <!-- filtrar bar -->
      <div class="row mt-4 no-printable">
        <div class="col-8">
          <v-select
            :items="categorias"
            label="Categorías"
            v-model="categoria"
            outlined
            item-text="nombre"
            item-value="id"
          ></v-select>
        </div>
        <div class="col-2 mt-1">
          <v-btn large color="grey" dark @click="buscarConsulta()">
            <v-icon class="mr-3">settings_overscan</v-icon>Filtrar
          </v-btn>
        </div>
        <div class="col-2 mt-1">
          <v-btn @click="resetFiltro()" outlined large color="grey" dark
            >Borrar filtro</v-btn
          >
        </div>
      </div>
      <!-- /filtrar bar -->

      <!-- tabla de ventas -->
      <div class="row mt-0 mb-5">
        <div class="col-12">
          <div>
            <div
              class="top d-flex align-items-center justify-content-between mb-3"
            >
              <h2 class="font-weight-black">Productos</h2>

              <v-btn @click="print()" large color="primary">
                <v-icon class="mr-3">print</v-icon>Imprimir
              </v-btn>
            </div>

            <!-- loader -->
            <div v-if="loaderVentas" class="text-center loader-wrap-min">
              <div
                class="spinner-border text-primary"
                style="width: 75px; height: 75px"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <!-- /loader -->

            <div v-if="!loaderVentas">
              <!-- datatable -->
              <v-card v-if="ventas != ''">
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="productos"
                  :search="search"
                >
                  <template v-slot:item.imagen_destacada="{ item }">
                    <img
                      :src="item.imagen_destacada"
                      alt
                      class="mr-3"
                      v-if="item.imagen_destacada != ''"
                      style="width: 40px; padding: 10px 0"
                    />
                    <img
                      src="https://image.flaticon.com/icons/svg/137/137665.svg"
                      alt
                      class="mr-3"
                      v-else
                      style="width: 40px; padding: 10px 0"
                    />
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <div v-if="item.estatus == 'pagada'">
                      <span class="badge badge-success">Pagada</span>
                    </div>
                    <div v-else>
                      <span class="badge badge-danger">Pago parcial</span>
                    </div>
                  </template>
                  <template v-slot:item.acciones="{ item }">
                    <v-btn
                      class="mx-2"
                      text
                      dark
                      small
                      color="primary"
                      :to="'/admin/venta/' + item.id"
                    >
                      <v-icon dark>visibility</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
              <!-- /datatable -->

              <!-- vacio -->
              <div v-if="ventas == ''">
                <div class="vacio">
                  <span>No hemos encontrado ventas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /tabla de ventas -->
    </div>
    <!-- /main -->
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      productos: [],
      loader: true,
      buscar: "",
      categorias: "",
      categoria: "",

      //Table
      search: "",
      headers: [
        {
          text: "#SKU",
          align: "left",
          sortable: false,
          value: "sku",
        },
        { text: "Imagen", value: "imagen_destacada" },
        { text: "Nombre", value: "nombre" },
        { text: "Categoría", value: "categoria" },
        { text: "Precio", value: "precio_pesos" },
        { text: "Inventario", value: "inventario" },
        { text: "Acciones", value: "acciones" },
      ],
    };
  },
  methods: {
    buscarConsulta() {
      if (this.categoria == "" || this.categoria == "selecciona") {
        //No seleccionaron la categoria
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Ingresa la categoría a la que pertenece el producto",
          showConfirmButton: true,
        });
      }
      //No ingresó término de búsqueda pero si la categoría
      else if (this.categoria != "" || this.categoria != "selecciona") {
        //Traemos todos los productos de la categoría
        this.loader = true;
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductosCategoria" +
              "&categoria=" +
              this.categoria
          )
          .then((response) => {
            console.log(response);
            this.productos = response.data;
            this.loader = false;
          })
          .catch((error) => console.log(error));
      } else {
        this.loader = true;
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=searchProductoInCategoria" +
              "&categoria=" +
              this.categoria +
              "&search=" +
              this.buscar
          )
          .then((response) => {
            console.log(response);
            this.productos = response.data;
            this.loader = false;
          })
          .catch((error) => console.log(error));
      }
    },
    resetFiltro() {
      this.loader = true;
      this.buscar = "";
      this.categoria = "selecciona";
      this.getProductos();
    },

    getCategorias() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategorias"
        )
        .then((response) => {
          this.categorias = response.data;
        })
        .catch((error) => console.log(error));
    },

    getProductos() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductos"
        )
        .then((response) => {
          console.log(response);
          this.productos = response.data;
          this.loader = false;
        })
        .catch((error) => console.log(error));
    },
    print() {
      window.print();
    },
  },
  mounted() {
    this.getProductos();
    this.getCategorias();
  },
};
</script>
